// import React, { useEffect, useState } from "react";
// import { useForm } from "react-hook-form";
// import { yupResolver } from "@hookform/resolvers/yup";
// import { FiEye, FiEyeOff } from "react-icons/fi";
// import { useDispatch, useSelector } from "react-redux";

// import { addUserFormValidation } from "../validationComponent/validationSchema";
// import {
//   createNormalUser,
//   resetUserState,
// } from "../../store/Slice/subadminSlice";

// import type { AppDispatch, RootState } from "../../store/store";

// interface FormData {
//   username: string;
//   email: string;
//   password: string;
//   employeeId?: string;
//   designation?: string;
//   department: string; // ✅ ADD
// }


// interface PermissionState {
//   resource: "orders" | "repairs" | "stock";
//   actions: string[];
// }

// interface SubadminAddUserFormProps {
//   onUserCreated?: () => void;
// }

// const DEFAULT_IMAGE =
//   "https://cdn.pixabay.com/photo/2023/02/18/11/00/icon-7797704_640.png";

// const SubadminAddUserForm: React.FC<SubadminAddUserFormProps> = ({
//   onUserCreated,
// }) => {
//   const dispatch = useDispatch<AppDispatch>();

//   /** ✅ FIX: correct slice */
//   const { loading, error, success } = useSelector(
//     (state: RootState) => state.user
//   );


//   const [showPassword, setShowPassword] = useState(false);
//   const [profileFile, setProfileFile] = useState<File | undefined>();
//   const [imagePreview, setImagePreview] = useState<string>(DEFAULT_IMAGE);
//   const [selectedDepartment, setSelectedDepartment] = useState<string>("");

//   const [permissions, setPermissions] = useState<PermissionState[]>([
//     { resource: "orders", actions: [] },
//     { resource: "repairs", actions: [] },
//     { resource: "stock", actions: [] },
//   ]);

//   const {
//     register,
//     handleSubmit,
//     reset,
//     formState: { errors },
//   } = useForm<FormData>({
//     resolver: yupResolver(addUserFormValidation),
//   });

//   /** =========================
//    *  EFFECT: RESET ON SUCCESS
//    *  ========================= */
//   useEffect(() => {
//     if (success) {
//       reset();
//       setSelectedDepartment("");
//       setPermissions([
//         { resource: "orders", actions: [] },
//         { resource: "repairs", actions: [] },
//         { resource: "stock", actions: [] },
//       ]);
//       setProfileFile(undefined);
//       setImagePreview(DEFAULT_IMAGE);

//       onUserCreated?.();

//       setTimeout(() => {
//         dispatch(resetUserState());
//       }, 2000);
//     }
//   }, [success, reset, dispatch, onUserCreated]);

//   /** =========================
//    *  HANDLERS
//    *  ========================= */
//   const togglePermission = (
//     resource: PermissionState["resource"],
//     action: string
//   ) => {
//     setPermissions((prev) =>
//       prev.map((perm) =>
//         perm.resource === resource
//           ? {
//             ...perm,
//             actions: perm.actions.includes(action)
//               ? perm.actions.filter((a) => a !== action)
//               : [...perm.actions, action],
//           }
//           : perm
//       )
//     );
//   };

//   const handleImageUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
//     const file = e.target.files?.[0];
//     if (!file) return;

//     setProfileFile(file);
//     const reader = new FileReader();
//     reader.onloadend = () => setImagePreview(reader.result as string);
//     reader.readAsDataURL(file);
//   };

//   const handleDepartmentChange = (deptId: string) => {
//     setSelectedDepartment(deptId);
//   };

//   /** =========================
//    *  SUBMIT
//    *  ========================= */
//  const onSubmit = async (data: FormData) => {
//   try {
//     const payload = {
//       username: data.username,
//       email: data.email,
//       password: data.password,
//       userType: "user",
//       employeeId: data.employeeId,
//       designation: data.designation,
//       department: data.department,
//       permissions,
//       profilePicture: profileFile,
//     };

//     await dispatch(createNormalUser(payload)).unwrap();
//   } catch (err) {
//     console.error("Create user failed:", err);
//   }
// };


//   const departments = [
//     { id: "sales", label: "Sales" },
//     { id: "production", label: "Production" },
//     { id: "accounts", label: "Accounts" },
//     { id: "rnd", label: "Research & Development" },
//     { id: "testing", label: "Testing" },
//     { id: "soldering", label: "Soldering" },
//     { id: "operation", label: "Operation" },
//   ];

//   /** =========================
//    *  JSX
//    *  ========================= */
//   return (
//     <form
//       onSubmit={handleSubmit(onSubmit)}
//       className="max-w-screen px-1 py-4 rounded-lg space-y-6"
//     >
//       <h1 className="text-2xl font-bold uppercase">
//         Create New User
//       </h1>

//       <div className="grid lg:grid-cols-2 gap-8">
//         {/* LEFT */}
//         <div className="bg-white dark:bg-zinc-800 p-6 rounded-xl shadow-lg space-y-5">
//           <h2 className="text-xl font-semibold">User Details</h2>

//           {/* Profile */}
//           <div className="relative w-24 h-24">
//             <img
//               src={imagePreview}
//               className="w-full h-full rounded-full object-cover border"
//               alt="profile"
//             />
//             <label
//               htmlFor="profile"
//               className="absolute bottom-0 left-0 w-6 h-6 bg-blue-600 text-white rounded-full flex items-center justify-center cursor-pointer"
//             >
//               +
//             </label>
//             <input
//               id="profile"
//               type="file"
//               accept="image/*"
//               onChange={handleImageUpload}
//               className="hidden"
//             />
//           </div>

//           <input
//             {...register("username")}
//             placeholder="Username"
//             className="w-full border px-4 py-2 rounded"
//           />
//           <p className="text-red-500 text-sm">{errors.username?.message}</p>

//           <input
//             {...register("email")}
//             placeholder="Email"
//             className="w-full border px-4 py-2 rounded"
//           />
//           <p className="text-red-500 text-sm">{errors.email?.message}</p>

//           <div className="flex border rounded">
//             <input
//               {...register("password")}
//               type={showPassword ? "text" : "password"}
//               placeholder="Password"
//               className="flex-1 px-4 py-2 outline-none"
//             />
//             <button
//               type="button"
//               onClick={() => setShowPassword((p) => !p)}
//               className="px-3"
//             >
//               {showPassword ? <FiEyeOff /> : <FiEye />}
//             </button>
//           </div>
//           <p className="text-red-500 text-sm">{errors.password?.message}</p>

//           <input
//             {...register("employeeId")}
//             placeholder="Employee ID"
//             className="w-full border px-4 py-2 rounded"
//           />

//           <input
//             {...register("designation")}
//             placeholder="Designation"
//             className="w-full border px-4 py-2 rounded"
//           />

//           {/* Department */}
//           <div>
//             <p className="font-semibold mb-2">Department</p>
//             {departments.map((d) => (
//               <label key={d.id} className="flex gap-2 items-center">
//                 <input
//                   type="radio"
//                   value={d.id}
//                   {...register("department")}
//                   onChange={() => handleDepartmentChange(d.id)}
//                 />

//                 {d.label}
//               </label>
//             ))}
//             {!selectedDepartment && (
//               <p className="text-red-500 text-sm">
//                 Department is required
//               </p>
//             )}
//           </div>
//         </div>

//         {/* RIGHT */}
//         <div className="bg-white dark:bg-zinc-800 p-6 rounded-xl shadow-lg">
//           <h2 className="text-xl font-semibold mb-4">
//             Permissions
//           </h2>

//           {permissions.map((perm) => (
//             <div key={perm.resource} className="border p-4 rounded mb-4">
//               <h3 className="font-bold uppercase">
//                 {perm.resource}
//               </h3>

//               {["read", "create", "update", "delete"].map((action) => (
//                 <label key={action} className="flex gap-2 mt-2">
//                   <input
//                     type="checkbox"
//                     checked={perm.actions.includes(action)}
//                     onChange={() =>
//                       togglePermission(perm.resource, action)
//                     }
//                   />
//                   <span className="capitalize">{action}</span>
//                 </label>
//               ))}
//             </div>
//           ))}
//         </div>
//       </div>

//       <button
//         type="submit"
//         disabled={loading || !selectedDepartment}
//         className="px-10 py-2 bg-[#0A2975] text-white rounded font-bold disabled:opacity-50"
//       >
//         {loading ? "Creating..." : "Create User"}
//       </button>

//       {error && <p className="text-red-500">{error}</p>}
//       {success && (
//         <p className="text-green-600">
//           User created successfully
//         </p>
//       )}
//     </form>
//   );
// };

// export default SubadminAddUserForm;

import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { FiEye, FiEyeOff, FiUser, FiMail, FiLock,  FiBriefcase, FiCheck, FiAlertCircle } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";

import { addUserFormValidation } from "../validationComponent/validationSchema";
import {
  createNormalUser,
  resetUserState,
} from "../../store/Slice/subadminSlice";

import type { AppDispatch, RootState } from "../../store/store";

interface FormData {
  username: string;
  email: string;
  password: string;
  employeeId?: string;
  designation?: string;
  department: string;
}

interface PermissionState {
  resource: "orders" | "repairs" | "stock";
  actions: string[];
}

interface SubadminAddUserFormProps {
  onUserCreated?: () => void;
}

const DEFAULT_IMAGE =
  "https://cdn.pixabay.com/photo/2023/02/18/11/00/icon-7797704_640.png";

const SubadminAddUserForm: React.FC<SubadminAddUserFormProps> = ({
  onUserCreated,
}) => {
  const dispatch = useDispatch<AppDispatch>();

  const { loading, error, success } = useSelector(
    (state: RootState) => state.user
  );

  const [showPassword, setShowPassword] = useState(false);
  const [profileFile, setProfileFile] = useState<File | undefined>();
  const [imagePreview, setImagePreview] = useState<string>(DEFAULT_IMAGE);
  const [selectedDepartment, setSelectedDepartment] = useState<string>("");

  const [permissions, setPermissions] = useState<PermissionState[]>([
    { resource: "orders", actions: [] },
    { resource: "repairs", actions: [] },
    { resource: "stock", actions: [] },
  ]);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<FormData>({
    resolver: yupResolver(addUserFormValidation),
  });

  useEffect(() => {
    if (success) {
      reset();
      setSelectedDepartment("");
      setPermissions([
        { resource: "orders", actions: [] },
        { resource: "repairs", actions: [] },
        { resource: "stock", actions: [] },
      ]);
      setProfileFile(undefined);
      setImagePreview(DEFAULT_IMAGE);

      onUserCreated?.();

      setTimeout(() => {
        dispatch(resetUserState());
      }, 2000);
    }
  }, [success, reset, dispatch, onUserCreated]);

  const togglePermission = (
    resource: PermissionState["resource"],
    action: string
  ) => {
    setPermissions((prev) =>
      prev.map((perm) =>
        perm.resource === resource
          ? {
              ...perm,
              actions: perm.actions.includes(action)
                ? perm.actions.filter((a) => a !== action)
                : [...perm.actions, action],
            }
          : perm
      )
    );
  };

  const handleImageUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    setProfileFile(file);
    const reader = new FileReader();
    reader.onloadend = () => setImagePreview(reader.result as string);
    reader.readAsDataURL(file);
  };

  const handleDepartmentChange = (deptId: string) => {
    setSelectedDepartment(deptId);
  };

  const onSubmit = async (data: FormData) => {
    try {
      const payload = {
        username: data.username,
        email: data.email,
        password: data.password,
        userType: "user",
        employeeId: data.employeeId,
        designation: data.designation,
        department: data.department,
        permissions,
        profilePicture: profileFile,
      };

      await dispatch(createNormalUser(payload)).unwrap();
    } catch (err) {
      console.error("Create user failed:", err);
    }
  };

  const departments = [
    { id: "sales", label: "Sales" },
    { id: "production", label: "Production" },
    { id: "accounts", label: "Accounts" },
    { id: "rnd", label: "Research & Development" },
    { id: "testing", label: "Testing" },
    { id: "soldering", label: "Soldering" },
    { id: "operation", label: "Operation" },
  ];

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className="w-full px-4 py-8 min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-50 dark:from-zinc-950 dark:via-zinc-900 dark:to-zinc-950 rounded-2xl space-y-8"
    >
      {/* HEADER SECTION */}
      <div className="space-y-2 animate-fade-in" data-aos="fade-down">
        <div className="flex items-center gap-3">
          <div className="w-1.5 h-8 bg-gradient-to-b from-blue-600 to-blue-400 rounded-full"></div>
          <h1 className="text-3xl lg:text-4xl font-bold bg-gradient-to-r from-blue-600 to-blue-800 dark:from-blue-400 dark:to-blue-300 bg-clip-text text-transparent">
            Create New User
          </h1>
        </div>
        <p className="text-gray-500 dark:text-gray-400 text-sm ml-4.5">
          Set up user account with permissions and access levels
        </p>
      </div>

      {/* MAIN GRID */}
      <div className="grid lg:grid-cols-2 gap-8">
        {/* LEFT SIDE - USER DETAILS */}
        <div
          className="flex flex-col gap-8 shadow-lg dark:shadow-2xl bg-white dark:bg-zinc-800/80 px-6 py-8 lg:px-8 lg:py-10 rounded-2xl backdrop-blur-sm border border-gray-100 dark:border-zinc-700 hover:shadow-xl dark:hover:shadow-2xl transition-all duration-300"
          data-aos="fade-right"
          data-aos-delay="100"
        >
          {/* SECTION TITLE */}
          <div className="space-y-1">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white flex items-center gap-2">
              <FiUser className="text-blue-600 dark:text-blue-400" size={24} />
              User Details
            </h2>
            <div className="h-1 w-12 bg-gradient-to-r from-blue-600 to-blue-400 rounded-full"></div>
          </div>

          {/* PROFILE IMAGE */}
          <div className="flex justify-center animate-fade-in-up" style={{ animationDelay: "0.1s" }}>
            <div className="relative group">
              <div className="absolute -inset-1 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-full blur opacity-0 group-hover:opacity-75 transition duration-300"></div>
              <div className="relative w-28 h-28 border-4 border-white dark:border-zinc-800 rounded-full shadow-lg overflow-hidden bg-gradient-to-br from-gray-100 to-gray-200 dark:from-zinc-700 dark:to-zinc-800">
                <img
                  src={imagePreview}
                  alt="Profile"
                  className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                />
                <label
                  htmlFor="profile"
                  className="absolute bottom-0 right-0 bg-gradient-to-br from-blue-600 to-blue-700 text-white w-8 h-8 rounded-full flex items-center justify-center cursor-pointer text-lg font-bold shadow-lg hover:from-blue-700 hover:to-blue-800 transition-all duration-200 transform hover:scale-110"
                >
                  +
                </label>
                <input
                  id="profile"
                  type="file"
                  accept="image/*"
                  onChange={handleImageUpload}
                  className="hidden"
                />
              </div>
            </div>
          </div>

          {/* INPUT FIELDS */}
          <div className="space-y-6">
            {/* USERNAME */}
            <div className="space-y-2 animate-fade-in-up" style={{ animationDelay: "0.15s" }}>
              <label className="text-sm font-semibold text-gray-700 dark:text-gray-300 flex items-center gap-2 uppercase tracking-wide">
                <FiUser size={16} className="text-blue-600" />
                Username
              </label>
              <input
                {...register("username")}
                placeholder="Enter username"
                className="w-full border-2 border-gray-300 dark:border-zinc-600 rounded-lg px-4 py-3 text-gray-900 dark:text-white dark:bg-zinc-700 placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 hover:border-blue-300 dark:hover:border-blue-500"
              />
              {errors.username?.message && (
                <p className="text-red-500 text-xs font-medium flex items-center gap-1 animate-pulse">
                  <FiAlertCircle size={14} /> {errors.username.message}
                </p>
              )}
            </div>

            {/* EMAIL */}
            <div className="space-y-2 animate-fade-in-up" style={{ animationDelay: "0.2s" }}>
              <label className="text-sm font-semibold text-gray-700 dark:text-gray-300 flex items-center gap-2 uppercase tracking-wide">
                <FiMail size={16} className="text-blue-600" />
                Email
              </label>
              <input
                {...register("email")}
                placeholder="Enter email address"
                className="w-full border-2 border-gray-300 dark:border-zinc-600 rounded-lg px-4 py-3 text-gray-900 dark:text-white dark:bg-zinc-700 placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 hover:border-blue-300 dark:hover:border-blue-500"
              />
              {errors.email?.message && (
                <p className="text-red-500 text-xs font-medium flex items-center gap-1 animate-pulse">
                  <FiAlertCircle size={14} /> {errors.email.message}
                </p>
              )}
            </div>

            {/* PASSWORD */}
            <div className="space-y-2 animate-fade-in-up" style={{ animationDelay: "0.25s" }}>
              <label className="text-sm font-semibold text-gray-700 dark:text-gray-300 flex items-center gap-2 uppercase tracking-wide">
                <FiLock size={16} className="text-blue-600" />
                Password
              </label>
              <div className="flex items-center border-2 border-gray-300 dark:border-zinc-600 rounded-lg hover:border-blue-300 dark:hover:border-blue-500 focus-within:ring-2 focus-within:ring-blue-500 focus-within:border-transparent transition-all duration-200 overflow-hidden">
                <input
                  {...register("password")}
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter password"
                  className="flex-1 px-4 py-3 outline-none text-gray-900 dark:text-white dark:bg-zinc-700 placeholder-gray-400 dark:placeholder-gray-500 bg-transparent"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword((p) => !p)}
                  className="px-3 text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors"
                >
                  {showPassword ? <FiEyeOff size={20} /> : <FiEye size={20} />}
                </button>
              </div>
              {errors.password?.message && (
                <p className="text-red-500 text-xs font-medium flex items-center gap-1 animate-pulse">
                  <FiAlertCircle size={14} /> {errors.password.message}
                </p>
              )}
            </div>
          </div>

          {/* EMPLOYMENT DETAILS SECTION */}
          <div className="pt-4 border-t-2 border-gray-200 dark:border-zinc-700 space-y-6">
            <h3 className="font-semibold text-gray-900 dark:text-white text-lg flex items-center gap-2">
              <FiBriefcase size={20} className="text-blue-600" />
              Employment Details
            </h3>

            {/* EMPLOYEE ID */}
            <div className="space-y-2 animate-fade-in-up" style={{ animationDelay: "0.3s" }}>
              <label className="text-sm font-semibold text-gray-700 dark:text-gray-300 flex items-center gap-2 uppercase tracking-wide">
                <FiUser size={16} className="text-blue-600" />
                Employee ID
              </label>
              <input
                {...register("employeeId")}
                placeholder="Enter employee ID"
                className="w-full border-2 border-gray-300 dark:border-zinc-600 rounded-lg px-4 py-3 text-gray-900 dark:text-white dark:bg-zinc-700 placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 hover:border-blue-300 dark:hover:border-blue-500"
              />
            </div>

            {/* DESIGNATION */}
            <div className="space-y-2 animate-fade-in-up" style={{ animationDelay: "0.35s" }}>
              <label className="text-sm font-semibold text-gray-700 dark:text-gray-300 flex items-center gap-2 uppercase tracking-wide">
                <FiBriefcase size={16} className="text-blue-600" />
                Designation
              </label>
              <input
                {...register("designation")}
                placeholder="Enter designation"
                className="w-full border-2 border-gray-300 dark:border-zinc-600 rounded-lg px-4 py-3 text-gray-900 dark:text-white dark:bg-zinc-700 placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 hover:border-blue-300 dark:hover:border-blue-500"
              />
            </div>

            {/* DEPARTMENT */}
            <div className="space-y-4 animate-fade-in-up" style={{ animationDelay: "0.4s" }}>
              <label className="text-sm font-semibold text-gray-700 dark:text-gray-300 flex items-center gap-2 uppercase tracking-wide">
                <FiBriefcase size={16} className="text-blue-600" />
                Select Department
              </label>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 p-4 bg-gray-50 dark:bg-zinc-700/50 rounded-xl border border-gray-200 dark:border-zinc-600">
                {departments.map((d) => (
                  <label
                    key={d.id}
                    className="flex items-center gap-3 p-3 cursor-pointer rounded-lg hover:bg-blue-50 dark:hover:bg-zinc-600 transition-all duration-200 border-2 border-transparent hover:border-blue-300 dark:hover:border-blue-500"
                  >
                    <input
                      type="radio"
                      value={d.id}
                      {...register("department")}
                      onChange={() => handleDepartmentChange(d.id)}
                      className="w-4 h-4 cursor-pointer accent-blue-600"
                    />
                    <span className="text-sm font-medium text-gray-700 dark:text-gray-300 cursor-pointer flex-1">
                      {d.label}
                    </span>
                    {selectedDepartment === d.id && (
                      <FiCheck size={16} className="text-green-600 dark:text-green-400 font-bold animate-pulse" />
                    )}
                  </label>
                ))}
              </div>

              {!selectedDepartment && (
                <p className="text-red-500 text-xs font-medium flex items-center gap-1 animate-pulse">
                  <FiAlertCircle size={14} /> Department is required
                </p>
              )}
            </div>
          </div>
        </div>

        {/* RIGHT SIDE - PERMISSIONS */}
        <div
          className="flex flex-col gap-6 shadow-lg dark:shadow-2xl bg-white dark:bg-zinc-800/80 px-6 py-8 lg:px-8 lg:py-10 rounded-2xl backdrop-blur-sm border border-gray-100 dark:border-zinc-700 hover:shadow-xl dark:hover:shadow-2xl transition-all duration-300"
          data-aos="fade-left"
          data-aos-delay="100"
        >
          {/* SECTION TITLE */}
          <div className="space-y-1">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white flex items-center gap-2">
              <FiCheck className="text-green-600 dark:text-green-400" size={24} />
              Permissions
            </h2>
            <div className="h-1 w-12 bg-gradient-to-r from-green-600 to-green-400 rounded-full"></div>
          </div>

          {/* PERMISSIONS GRID */}
          <div className="space-y-4">
            {permissions.map((perm, idx) => (
              <div
                key={perm.resource}
                className="border-2 border-gray-200 dark:border-zinc-600 p-5 rounded-xl bg-gradient-to-br from-gray-50 to-gray-100 dark:from-zinc-700/50 dark:to-zinc-800/50 hover:border-blue-300 dark:hover:border-blue-500 transition-all duration-300 hover:shadow-md animate-fade-in-up"
                style={{ animationDelay: `${0.15 + idx * 0.1}s` }}
              >
                {/* RESOURCE NAME */}
                <h3 className="font-bold uppercase text-base text-blue-700 dark:text-blue-400 mb-4 flex items-center gap-2 tracking-wide">
                  <div className="w-2.5 h-2.5 bg-blue-600 dark:bg-blue-400 rounded-full"></div>
                  {perm.resource}
                </h3>

                {/* ACTION CHECKBOXES */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  {["read", "create", "update", "delete"].map((action) => (
                    <label
                      key={action}
                      className="flex items-center gap-3 p-2 rounded-lg cursor-pointer hover:bg-white dark:hover:bg-zinc-600/50 transition-all duration-200 group"
                    >
                      <input
                        type="checkbox"
                        checked={perm.actions.includes(action)}
                        onChange={() => togglePermission(perm.resource, action)}
                        className="w-4 h-4 cursor-pointer accent-blue-600"
                      />
                      <span className="capitalize text-sm font-medium text-gray-700 dark:text-gray-300 group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-colors cursor-pointer flex-1">
                        {action}
                      </span>
                      {perm.actions.includes(action) && (
                        <FiCheck size={14} className="text-green-600 dark:text-green-400 font-bold" />
                      )}
                    </label>
                  ))}
                </div>
              </div>
            ))}
          </div>

          {/* PERMISSIONS INFO */}
          <div className="p-4 bg-blue-50 dark:bg-blue-900/30 border border-blue-200 dark:border-blue-800 rounded-lg text-xs text-blue-800 dark:text-blue-300 italic">
            ℹ️ Grant permissions for resource access control
          </div>
        </div>
      </div>

      {/* SUBMIT BUTTON & STATUS */}
      <div className="flex flex-col gap-4 pt-4 animate-fade-in" style={{ animationDelay: "0.8s" }}>
        <button
          type="submit"
          disabled={loading || !selectedDepartment}
          className="w-full lg:w-fit lg:px-12 px-6 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 active:from-blue-800 active:to-blue-900 text-white font-bold py-3 rounded-lg shadow-lg hover:shadow-xl dark:shadow-2xl dark:hover:shadow-2xl duration-200 cursor-pointer transition-all transform hover:scale-105 active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100 flex items-center justify-center gap-2 text-lg"
        >
          {loading ? (
            <>
              <span className="inline-block animate-spin">⏳</span>
              Creating...
            </>
          ) : (
            <>
              <FiCheck size={20} />
              Create User
            </>
          )}
        </button>

        {/* ERROR MESSAGE */}
        {error && (
          <div className="p-4 bg-red-50 dark:bg-red-900/30 border-l-4 border-red-600 rounded-lg text-red-700 dark:text-red-400 text-sm font-medium animate-pulse flex items-center gap-2">
            <FiAlertCircle size={18} />
            {error}
          </div>
        )}

        {/* SUCCESS MESSAGE */}
        {success && (
          <div className="p-4 bg-green-50 dark:bg-green-900/30 border-l-4 border-green-600 rounded-lg text-green-700 dark:text-green-400 text-sm font-medium animate-pulse flex items-center gap-2">
            <FiCheck size={18} className="font-bold" />
            User created successfully
          </div>
        )}
      </div>

      {/* CSS ANIMATIONS */}
      <style>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(15px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .animate-fade-in {
          animation: fadeIn 0.6s ease-out forwards;
        }

        .animate-fade-in-up {
          animation: fadeInUp 0.6s ease-out forwards;
          opacity: 0;
        }
      `}</style>
    </form>
  );
};

export default SubadminAddUserForm;